module.exports = __webpack_public_path__ + "static/empty-states-illustrations-do-c5fe702b07f4b1d1e34f7306b7126f2d.png";